export const initialDocumentState = {
  loading: false,
  error: null,
  dataDocument: null,
};
